import React from 'react';

import PropTypes from 'prop-types';
import cn from 'classnames';
import { HiChevronRight } from 'react-icons/hi';

import { Text, Badge } from 'modules/common';

import * as c from './constants';

function NavItem({
  withLeading,
  leadingItem,
  withBadge,
  label,
  type,
  isActive,
  disabled,
  badgeProps,
  onClick,
  className,
  withChevron,
  chevronClassName,
  width,
}) {
  let $type = c.TYPE_OPTS({ isActive, type, withChevron });
  $type = disabled ? $type?.disabled : $type?.[type];

  const style = {
    background: $type?.background,
    padding: $type?.padding,
    border: $type?.border,
    text: $type?.text,
  };

  return (
    <div
      className={cn(
        'flex items-center gap-ds-8 rounded py-ds-8 cursor-pointer text-muted',
        style.background,
        style.padding,
        style.border,
        style.text,
        className
      )}
      onClick={onClick}
      role="presentation"
      style={{ width }}
    >
      {withLeading && leadingItem}

      <Text weight="semibold" className={cn('py-[3px] flex-1', style.text)}>
        {label}
      </Text>

      {withBadge && (
        <Badge
          type="danger"
          disabled={disabled}
          withLeading={false}
          withClose={false}
          className="!gap-0"
          {...badgeProps}
        />
      )}

      {withChevron && (
        <HiChevronRight
          className={cn('h-5 w-5', chevronClassName, {
            'rotate-90 text-brand-primary-base': isActive,
            'text-muted': !isActive,
          })}
        />
      )}
    </div>
  );
}

NavItem.defaultProps = {
  type: 'default',
  isActive: false,
  withLeading: true,
  label: '',
  chevronClassName: '',
  leadingItem: false,
  withBadge: false,
  disabled: false,
  withChevron: false,
  badgeProps: {},
  onClick: () => {},
  className: '',
  width: '100%',
};

const PROP_TYPES_TYPE = Object.keys(c.TYPE_OPTS())?.filter(
  (item) => item !== 'disabled'
);

NavItem.propTypes = {
  type: PropTypes.oneOf(PROP_TYPES_TYPE),
  label: PropTypes.string,
  className: PropTypes.string,
  chevronClassName: PropTypes.string,
  width: PropTypes.string,
  isActive: PropTypes.bool,
  withChevron: PropTypes.bool,
  withLeading: PropTypes.bool,
  disabled: PropTypes.bool,
  leadingItem: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.element,
    PropTypes.string,
    PropTypes.instanceOf(Object),
    PropTypes.instanceOf(Function),
  ]),
  withBadge: PropTypes.bool,
  badgeProps: PropTypes.instanceOf(Object),
  onClick: PropTypes.instanceOf(Function),
};

export default NavItem;
